
import * as INTERFACE from './interface';
export * from './interface';
export default INTERFACE;



// WEBPACK FOOTER //
// ./src/index.js